(function(){
  var dlg=document.getElementById('rgMagicPicker');
  if(!dlg||dlg.dataset.ready)return;dlg.dataset.ready='1';
  var q=dlg.querySelector('[data-rgmp-q]'),grid=dlg.querySelector('[data-rgmp-grid]'),tabs=dlg.querySelector('.rgmp__tabs'),
      cache={},all=null,active='classic-collection-turkish-towels',timer;
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
  function img(u,w){if(!u)return '';return u+(u.indexOf('?')>-1?'&':'?')+'width='+(w||400);}
  function card(p){
    var rt=(p.title.match(/RT\d+/i)||[''])[0].toUpperCase(),name=p.title.replace(/\s*[-–]?\s*RT\d+.*$/i,'').replace(/ Turkish (Beach )?Towel.*$/i,' Towel');
    var src=p.images&&p.images[0]?p.images[0].src:(p.image||'');
    return '<a class="rgmp__item" href="/products/'+esc(p.handle)+'?magic=1"><span class="rgmp__img"><img loading="lazy" src="'+esc(img(src,400))+'" srcset="'+esc(img(src,400))+' 1x, '+esc(img(src,800))+' 2x" alt=""></span><span class="rgmp__n">'+(rt?'<b>'+rt+'</b>':'')+esc(name)+'</span></a>';
  }
  function show(list,msg){grid.innerHTML=list.length?list.map(card).join(''):'<p class="rgmp__msg">'+(msg||'No towels found. Try a different name or RT number.')+'</p>';}
  function load(h){
    if(cache[h])return Promise.resolve(cache[h]);
    return fetch('/collections/'+h+'/products.json?limit=100').then(function(r){return r.json()}).then(function(d){cache[h]=d.products||[];return cache[h]});
  }
  function loadAll(){
    if(all)return Promise.resolve(all);
    var hs=[].map.call(tabs.querySelectorAll('[data-rgmp-tab]'),function(b){return b.dataset.rgmpTab});
    return Promise.all(hs.map(load)).then(function(a){var seen={};all=[].concat.apply([],a).filter(function(p){if(seen[p.handle])return false;seen[p.handle]=1;return true});return all});
  }
  function tab(h){
    active=h;[].forEach.call(tabs.querySelectorAll('button'),function(b){b.classList.toggle('is-on',b.dataset.rgmpTab===h)});
    grid.innerHTML='<p class="rgmp__msg">Loading towels...</p>';
    load(h).then(function(l){if(!q.value.trim())show(l)}).catch(function(){grid.innerHTML='<p class="rgmp__msg">Could not load towels. Please try again.</p>'});
  }
  function search(v){
    v=v.trim().toLowerCase();
    if(v.length<2){tabs.hidden=false;tab(active);return;}
    tabs.hidden=true;
    loadAll().then(function(a){
      var t=v.replace(/\s+/g,'');
      var r=a.filter(function(p){var s=p.title.toLowerCase();return s.indexOf(v)>-1||s.replace(/\s+/g,'').indexOf(t)>-1||(p.handle||'').indexOf(v.replace(/\s+/g,'-'))>-1});
      if(r.length||!/^[a-z0-9 -]{2,}$/i.test(v)){show(r);return;}
      return fetch('/search/suggest.json?q='+encodeURIComponent(v)+'&resources[type]=product&resources[limit]=12').then(function(x){return x.json()}).then(function(d){
        var ps=(d.resources&&d.resources.results&&d.resources.results.products)||[];
        show(ps.map(function(p){return {title:p.title,handle:p.handle,images:[{src:p.image}]}}));
      });
    }).catch(function(){show([],'Search is unavailable right now.')});
  }
  [].forEach.call(tabs.querySelectorAll('[data-rgmp-tab]'),function(b){b.addEventListener('click',function(){tab(b.dataset.rgmpTab)})});
  q.addEventListener('input',function(){clearTimeout(timer);timer=setTimeout(function(){search(q.value)},220)});
  function open(e){
    if(e)e.preventDefault();
    if(typeof dlg.showModal==='function'){if(!dlg.open)dlg.showModal();}else dlg.setAttribute('open','');
    q.value='';tabs.hidden=false;tab(active);setTimeout(function(){q.focus()},50);
  }
  function close(){if(dlg.close)dlg.close();else dlg.removeAttribute('open')}
  dlg.querySelector('[data-rgmp-close]').addEventListener('click',close);
  dlg.addEventListener('click',function(e){if(e.target===dlg)close()});
  document.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('[data-rg-magic-pick]');if(a)open(e)});
})();
